import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { HardHat } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUserExternal } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    const pendingRole = localStorage.getItem("pending_role") || "client";

    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post(
          "/auth/session",
          { role: pendingRole },
          { headers: { "X-Session-ID": sessionId } }
        );
        localStorage.removeItem("pending_role");
        setUserExternal(data);
        // strip hash from URL
        window.history.replaceState(null, "", window.location.pathname);
        toast.success("¡Sesión iniciada con Google!");
        if (data.is_new || data.role === "pending") navigate("/onboarding", { replace: true });
        else if (data.role === "admin") navigate("/admin", { replace: true });
        else if (data.role === "business") navigate("/dashboard", { replace: true });
        else navigate("/directory", { replace: true });
      } catch (e) {
        setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
      }
    })();
  }, [navigate, setUserExternal]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-secondary text-white" data-testid="auth-callback">
      <span className="flex h-12 w-12 items-center justify-center rounded-sm bg-primary"><HardHat className="h-6 w-6" /></span>
      {error ? (
        <div className="mt-6 text-center">
          <p className="text-sm text-red-300">{error}</p>
          <button onClick={() => navigate("/login")} className="mt-3 text-sm font-semibold text-primary underline">Volver a iniciar sesión</button>
        </div>
      ) : (
        <div className="mt-6 h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
      )}
    </div>
  );
}
